/* eslint-disable react/prop-types */

import React from "react"
import { Card, Avatar, Progress } from "antd"
import { Link } from "react-router-dom";
import { CheckCircleTwoTone, CloseCircleTwoTone } from "@ant-design/icons";
import points_icon from "assets/images/icon-points.png"
import points_icon_disabled from "assets/images/icon-points-off.png"
import { isNumber } from "lodash";
const quizStates = {
    "inprogress":{title:"In Progress",color:"blue"},
    "completed":{title:"Completed",color:"green"},
    "notstarted":{title:"Not Started",color:"grey"}
}
class QuizAttemptCard extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const { details = {} ,showLinks=true} = this.props;
        const { avatar, id, name, attempts = {}, points = "0", status } = details
        const {correct=0, total=0} = attempts;
        const quizState = quizStates[status]?quizStates[status] : quizStates["notstarted"]
        
        return (<Card bordered={true} style={{ marginBottom: 10, padding: 3 }} bodyStyle={{ margin: 0, padding: 0 }}>
            <div style={{display:"flex", flexDirection:"row"}}>
                <div style={{...styles.centerColumnFlex,...styles.seperatorRight,minWidth:"50%",alignItems: "flex-start"}}>
                    <div style={{display:"flex", flexDirection:"row", justifyContent:"center",alignItems: "center"}}>
                        <Avatar src={avatar} />
                        {showLinks?<Link to={`/main/student/${id}`} style={{paddingLeft:"5px"}}> {name}</Link>:<span style={{paddingLeft:"5px"}}> {name}</span>}
                    </div>
                </div>
                <div style={{...styles.centerColumnFlex, ...styles.seperatorRight}}> 
                    <div style={styles.rowFlex}>
                        <div style={{padding:"5px"}}><CheckCircleTwoTone twoToneColor="#52c41a" style={{padding:"2px"}}/><span>{correct}</span></div>
                        <div style={{padding:"5px"}}><CloseCircleTwoTone twoToneColor="#FF1010" style={{padding:"2px"}}/><span>{isNumber(total-correct)?total-correct: "0"}</span></div>
                    </div>
                    {/* <div style={{...styles.rowFlex, paddingTop:"5px"}}></div> */}
                </div>
                <div style={styles.centerColumnFlex}>
                    <div style={styles.rowFlex}><img src={status === "notstarted"?points_icon_disabled:points_icon}  height={24}/> <span style={{ padding:4}}>{points}</span></div>
                </div>
                {quizState && <div style={{...styles.centerColumnFlex, background:quizState.color, ...styles.quizStateTag}}>{quizState.title}</div>}
            </div>
            <div style={{width:"100%"}}>
                        {(status !== 'notstarted') && (
                            <div>
                                <Progress style={{width:"100%", padding:0,margin:0}} showInfo={false} percent={total * 10} size="small" strokeWidth="3px" status={status !== 'completed' ? "active" : "success"} height="2px"/>
                            </div>)
                        }
            </div>
        </Card>)
    }
}

const styles = {
    quizStateTag: { color: "#FFF", padding: "2px 6px", margin: "0px", position: "absolute", top: "5px", right: "10px", borderRadius: "5px", fontSize: "8px",fontWeight:"normal" },
    seperatorRight:{borderRightWidth:"4px",borderRightColor:"rgb(165 165 165 / 25%)",borderRightStyle:"solid", padding:"5px"},
    rowFlex:{display:"flex", flexDirection:"row"},
    centerColumnFlex:{display:"flex", flexDirection:"column",justifyContent:"center",alignItems: "center", padding: "5px"}
}
export default QuizAttemptCard